import { useLocation } from "wouter";
import { ShieldOff, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";

export default function AccessDenied() {
  const [, navigate] = useLocation();
  const { logout } = useAuth();

  const handleLogout = () => {
    logout(); // já navega pra /login
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--solar-bg)] p-4">
      <div className="text-center max-w-md w-full rounded-xl border border-[var(--solar-line)] bg-white shadow-[var(--elev-2)] p-8">
        <div className="h-20 w-20 rounded-full bg-red-50 border border-red-200 flex items-center justify-center mx-auto mb-6">
          <ShieldOff className="h-10 w-10 text-[var(--destructive)]" />
        </div>
        <h1 className="text-3xl font-bold text-[var(--solar-ink)] mb-3">Acesso Negado</h1>
        <p className="text-[var(--ink-2)] mb-2">
          Sua conta não tem permissão para acessar este ambiente.
        </p>
        <p className="text-[var(--solar-mute)] text-sm mb-8">
          Cada ambiente da plataforma RAZ é exclusivo para os usuários convidados por aquele cliente.
          Se você acredita que deveria ter acesso, entre em contato com o administrador.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button
            variant="outline"
            onClick={() => navigate(-1 as unknown as string)}
            className="border-[var(--solar-line)] text-[var(--solar-ink)] hover:bg-[var(--secondary)]"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Voltar
          </Button>
          <Button
            onClick={handleLogout}
            className="bg-[var(--solar-ink)] hover:opacity-90 text-white shadow-[var(--elev-1)]"
          >
            Sair e fazer login no ambiente correto
          </Button>
        </div>
        <p className="text-[var(--solar-mute)] text-xs mt-8">
          RAZ Consulting · Plataforma de Inteligência Estratégica
        </p>
      </div>
    </div>
  );
}
